/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcphosted_Hub_OverlineInputs */

const en_mcphosted_hub_overline = /** @type {(inputs: Mcphosted_Hub_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hosted MCP`)
};

const id_mcphosted_hub_overline = /** @type {(inputs: Mcphosted_Hub_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MCP hosted`)
};

/**
* | output |
* | --- |
* | "Hosted MCP" |
*
* @param {Mcphosted_Hub_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mcphosted_hub_overline = /** @type {((inputs?: Mcphosted_Hub_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcphosted_Hub_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mcphosted_hub_overline(inputs)
	return en_mcphosted_hub_overline(inputs)
});